import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { MenutTreeStoreContext } from './contexts/StoreContext'
import { ResourceBaseTreeStoreProviderProps } from './interface'
import { createResourceBaseTreeStore } from './store/createStore'

export const ResourceBaseTreeStoreProvider = ({
  defaultExpandAll,
  data,
  children
}: PropsWithChildren<ResourceBaseTreeStoreProviderProps>) => {
  const store = useCreation(
    () => createResourceBaseTreeStore({ defaultExpandAll, data }),
    [data]
  )

  return <MenutTreeStoreContext value={store}>{children}</MenutTreeStoreContext>
}
